import React, { useMemo } from "react";
import { useParams, useSearchParams } from "react-router-dom";

import OrderTicketsView from "./OrderTicketsView";

/**
 * Main site: /my-tickets/:orderId?token=
 */
const MyTicketsContainer = () => {
  const { orderId } = useParams();
  const [searchParams] = useSearchParams();

  const loginReturnPath = useMemo(() => {
    const q = searchParams.toString();
    return `/my-tickets/${orderId}${q ? `?${q}` : ""}`;
  }, [orderId, searchParams]);

  return (
    <div className="my-tickets-page min-vh-100 py-3 py-sm-4">
      <OrderTicketsView
        orderId={orderId}
        searchParams={searchParams}
        loginReturnPath={loginReturnPath}
      />
    </div>
  );
};

export default MyTicketsContainer;
